import React from 'react';
import './StatCard.css';

export default function StatCard({ title, value, subtitle, tone = 'primary', Icon }) {
  return (
    <div className={`stat-card ${tone}`}>
        <div className="icon" aria-hidden>{Icon ? <img src={Icon} alt="Icon" className='img-fluid' /> : null}</div>
        <div className="meta">
          <div className="title">{title}</div>
          <div className="value">{value}</div>
          {subtitle && <div className="subtitle">{subtitle}</div>}
        </div>
    </div>
  );
}

